import { z } from 'zod';
export const fipThresholdsSchema = z.object({
    delinquencyRateThreshold: z.number(),
    apPressureThreshold: z.number(),
    budgetVarianceThreshold: z.number(),
    liquidityRunwayMinMonths: z.number(),
});
export const fipThresholdOverridesSchema = fipThresholdsSchema
    .partial()
    .transform((raw) => {
    const overrides = {};
    if (raw.delinquencyRateThreshold !== undefined) {
        overrides.delinquencyRateThreshold = raw.delinquencyRateThreshold;
    }
    if (raw.apPressureThreshold !== undefined) {
        overrides.apPressureThreshold = raw.apPressureThreshold;
    }
    if (raw.budgetVarianceThreshold !== undefined) {
        overrides.budgetVarianceThreshold = raw.budgetVarianceThreshold;
    }
    if (raw.liquidityRunwayMinMonths !== undefined) {
        overrides.liquidityRunwayMinMonths = raw.liquidityRunwayMinMonths;
    }
    return overrides;
});
//# sourceMappingURL=fip.js.map